"use strict";
import MODES from "../modes";
import {
  CHANGE_MODE
} from "../actions";
export default function modesReducer(mode = {
  type: MODES.selectOrMove,
  meta: {}
}, action) {
  switch (action.type) {
    case CHANGE_MODE:
      return {
        type: action.name,
        meta: action.meta
      };
    default:
      return mode;
  }
}
